import React from "react";

import styles from "./ErrorView.module.css";

interface ErrorObject {
  message?: string;
  stack?: string;
  json?: {
    code?: number;
    message?: string;
  };
}

interface ErrorViewProps {
  error?: ErrorObject;
}

const ErrorView: React.FC<ErrorViewProps> = ({ error = {} }) => {
  const { message, stack, json } = error;

  return (
    <div className={styles.errorContainer}>
      <span className={styles.errorTitle}>
        Failed to get status report from server.
      </span>
      <br />
      <br />
      <a href={window.location.href} onClick={() => window.location.reload()}>
        Click here to refresh.
      </a>

      <div className={styles.errorStacktrace}>
        {json ? (
          <div>
            Response code: {json.code}
            <br />
          </div>
        ) : (
          ""
        )}
        <div>Response body: {json ? json.message : message}</div>
        <div>
          <pre>{stack ? stack.toString() : "No stacktrace available."}</pre>
        </div>
      </div>
    </div>
  );
};

export default ErrorView;
